/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Modal,
  DatePicker,
  Input,
  Loading,
} from "../../../core";
import { MixStyle } from "../../../styles";
import styled from "styled-components";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Row, Col, Space, Select } from "antd";
import { getyarnQualities } from "../../../helper/utils/api/settings";
import { addyarnReceived } from "../../../helper/utils/api/yarnIssuence";

const Notify_Utils = require("../../../helper/utils/Notification");

const { Option } = Select;

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const YarnReceivedModal = ({
  contractDetails,
  yarnReceivedModal,
  closeModalHandler,
}) => {
  const [form] = Form.useForm();
  const [yarnQualities, setYarnQualities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let companyId = localStorage.getItem("companyId");
  console.log("contractDetails", contractDetails);
  useEffect(() => {
    getYarnQualitiesHandler();
  }, [companyId]);

  const getYarnQualitiesHandler = async () => {
    setIsLoading(true);
    try {
      let response = await getyarnQualities({ companyId });
      setYarnQualities(response.data.result);
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };

  const onFinish = async (fieldsValue) => {
    console.log("fieldsValue=>", fieldsValue);
    let yarnReceivedDataPayload = {
      ...fieldsValue,
      contractId: contractDetails._id,
      companyId: contractDetails.companyId,
    };
    setIsLoading(true);
    await addYarnReceivedApi(yarnReceivedDataPayload);
    setIsLoading(false);
  };

  const addYarnReceivedApi = async (data) => {
    console.log("yarnReceivedDataPayload", data);

    debugger;
    setIsLoading(true);
    try {
      let response = await addyarnReceived(data);
      console.log("response", response);
      Notify_Utils.openNotificationWithIcon("success", response.data.message);
      closeModalHandler("yarnReceivedModal");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While update Dispatch"
      );
      console.log("error while update", error);
    }
  };

  const onFinishFailed = (errorInfo) => {};

  const onValuesChange = (changedValues, valuse) => {};

  return (
    <Modal
      closable={true}
      visible={yarnReceivedModal}
      okText="Add"
      maxwidth="660px"
      footer={false}
      onCancel={() => closeModalHandler("yarnReceivedModal")}
      tittle="Yarn Received"
    >
      {isLoading && <Loading />}
      <StyledForm
        autocomplete="off"
        name="nest-messages"
        form={form}
        {...layout}
        // name="basic"
        initialValues={{
          yarn_receives_variant: [""],
        }}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={18} sm={18} xs={24}>
            <Form.Item
              label="Do #"
              name="DoNo"
              rules={[
                {
                  required: true,
                  message: "Please Enter Do #",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={18} sm={18} xs={24}>
            <Form.Item
              label="Date"
              name="yarnRecievedDate"
              rules={[
                {
                  required: true,
                  message: "Please Set Date!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={18} sm={18} xs={24}>
            <Form.Item
              label="Brand (Yarn Quality)"
              name="yarnReceivedQuality"
              rules={[
                {
                  required: true,
                  message: "Please select Brand",
                },
              ]}
            >
              <Select defaultValue="count/consize/brand/type">
                <Option value="count/consize/brand/type">
                  Yarn Quality (count/consize/brand/type)
                </Option>
                {yarnQualities.map((data, index) => (
                  <Option
                    value={`${data.count}/${data.consize}/${data.brand}/${data.type}`}
                  >
                    {data.count}/{data.consize}/{data.brand}/{data.type}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.List name="yarnReceivedQuantity">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    {fields.map((field, index) => (
                      <Space
                        key={field.key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="start"
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "yarnReciedFor"]}
                          fieldKey={[field.fieldKey, "yarnReciedFor"]}
                          rules={[
                            { required: true, message: "Plz Enter category" },
                          ]}
                        >
                          <Select defaultValue="">
                            <Option value="">Select One Category</Option>
                            <Option value="warp">warp</Option>
                            <Option value="weft">weft</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "bags"]}
                          fieldKey={[field.fieldKey, "bags"]}
                          rules={[{ required: true, message: "Input Bags" }]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder="Bags"
                            // prefix={<UserOutlined />}
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "Cons"]}
                          fieldKey={[field.fieldKey, "Cons"]}
                          rules={[{ required: true, message: "Input Rate" }]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder="Cons"
                            // prefix={<UserOutlined />}
                          />
                        </Form.Item>

                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        width="187px"
                        margin="auto"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                          // setVariant(true);
                        }}
                      >
                        <PlusOutlined /> Add Variation
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
        </Row>

        <Row type="flex" justify="center">
          {/* <Col md={13} sm={18} xs={24}></Col> */}

          <Col xs={16} sm={12}>
            <Row type="flex" justify="space-between">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button
                  bg="#404E67"
                  type="primary"
                  // onClick={onCancel}
                >
                  <Typography
                    text="cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default YarnReceivedModal;
